import { cloneElement } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

const FormWrapper = ({ children, ...other }) => cloneElement(children, other);

FormWrapper.propTypes = { children: PropTypes.element.isRequired };

export default reduxForm({})(FormWrapper);
